import { useTranslation } from 'react-i18next';

type SystemEventKind = 'joined' | 'handback' | 'reassigned';

interface HandoffSystemEventProps {
  kind: SystemEventKind;
  trferName?: string;
  /**
   * The family's own companion persona (#639). Required — a handback is the
   * moment a human leaves the conversation, so naming the wrong companion
   * here is the worst place to get it wrong. MessageList passes its
   * `personaName`, which ChatPage resolves from the family's voice persona.
   */
  companionName: string;
}

export function HandoffSystemEvent({ kind, trferName, companionName }: HandoffSystemEventProps) {
  const { t } = useTranslation('chat');
  const name = trferName?.trim() || t('handoff.aCaseManager');
  const text =
    kind === 'joined' ? t('handoff.event.joined', { name }) :
    kind === 'handback' ? t('handoff.event.handback', { name, companion: companionName }) :
    t('handoff.event.reassigned', { name });
  return (
    <div className="flex justify-center my-3">
      <div className="text-label font-semibold text-status-warn-fg bg-status-warn border border-status-warn-border rounded-full px-3 py-1 font-mono">
        {text}
      </div>
    </div>
  );
}
